import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import { SanitizePipe } from './sanitize.pipe';
import { CapitalizePipe } from './capitalize.pipe';
import { SprintfPipe } from './sprintf.pipe';
import { MetricUnitPrefixPipe } from './metric-unit-prefix.pipe';
import { MonetaryUnitPrefixPipe } from './monetary-unit-prefix.pipe';
import { LocalizedNumberPipe } from './localized-number.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    SanitizePipe,
    CapitalizePipe,
    SprintfPipe,
    MetricUnitPrefixPipe,
    MonetaryUnitPrefixPipe,
    LocalizedNumberPipe
  ],
  exports: [
    SanitizePipe,
    CapitalizePipe,
    SprintfPipe,
    MetricUnitPrefixPipe,
    MonetaryUnitPrefixPipe,
    LocalizedNumberPipe
  ]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/app/core/pipes/pipes.module.ts